var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { UPLOAD_URL, IMAGE_SIZE, formatImageUrl, } from '@/common/utils/qiniu-constant';
var QiniuUpload = /** @class */ (function (_super) {
    __extends(QiniuUpload, _super);
    function QiniuUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.actionUrl = UPLOAD_URL; // 上传地址
        _this.uploadFileList = []; // 上传列表
        _this.previewImg = ''; // 预览图片的url
        _this.previewDialog = false; // 预览图片的dialog
        _this.watermark = ''; // 水印
        _this.singleUrl = ''; // 单张图片时
        _this.previewWm = IMAGE_SIZE.large; // 默认预览大图的水印
        return _this;
    }
    Object.defineProperty(QiniuUpload.prototype, "uploadData", {
        get: function () {
            var qiniuToken = this.$store.getters['getQiniuToken'];
            if (typeof qiniuToken[this.uploadParams.bucket] === 'string') {
                return null;
            }
            return qiniuToken[this.uploadParams.bucket];
        },
        enumerable: false,
        configurable: true
    });
    /* watch */
    QiniuUpload.prototype.uploadParamsHandler = function (newVal) {
        this.uploadFileList = newVal.uploadFileList.map(function (img) {
            if (Object.prototype.toString.call(img) === '[object Object]') {
                // eslint-disable-next-line no-prototype-builtins
                if (!img.hasOwnProperty('url')) { // 对象必须有url字段
                    throw new Error('assignment error: url is required.');
                }
                return img; // 对象
            }
            else {
                return {
                    url: img,
                };
            }
        });
    };
    QiniuUpload.prototype.mounted = function () {
        var uploadData = this.uploadData;
        if (!uploadData || !uploadData.token || uploadData.expiry < new Date().getTime()) {
            this.getToken();
        }
    };
    /* methods */
    // 获取七牛token
    QiniuUpload.prototype.getToken = function () {
        this.$store.dispatch('$_UpdateQiniuToken', this.uploadParams.bucket);
    };
    // 预览大图
    QiniuUpload.prototype.imgPreview = function (file) {
        if (this.uploadParams.isFile || this.getFileType(file.name) === 'file') {
            location.href = file.url;
        }
        else {
            this.previewImg = file.url;
            this.previewDialog = true;
        }
    };
    QiniuUpload.prototype.formatImageUrl = function (url, type) {
        return formatImageUrl(url, type);
    };
    // 判断上传的是文件还是图片
    QiniuUpload.prototype.getFileType = function (name) {
        if (name) {
            var type = 'img'; // 默认图片
            // 获取文件后缀名
            var stringLen = name.length;
            var suffixIndex = name.lastIndexOf('.');
            var fileType = name.substring(suffixIndex, stringLen);
            var fileTypeArr = [
                '.xls',
                '.xlsx',
                '.doc',
                '.docx',
                '.ppt',
                '.pptx',
                '.pdf',
            ];
            if (fileTypeArr.indexOf(fileType) !== -1) {
                type = 'file';
            }
            return type;
        }
        else {
            return false;
        }
    };
    // 超过限制数量时的提示语
    QiniuUpload.prototype.exceedMessage = function () {
        this.$message.warning(this.uploadParams.exceed_message);
    };
    // 上传文件之前
    QiniuUpload.prototype.beforeUpload = function (file) {
        var size = file.size / 1024 / 1024;
        var uploadParams = this.uploadParams;
        if (this.uploadFileList.length === uploadParams.limit) {
            this.$message.warning("\u6700\u591A\u4E0A\u4F20" + uploadParams.limit + "\u4E2A\u6587\u4EF6");
            return false;
        }
        if (size > uploadParams.size) {
            this.$message.warning("\u4E0A\u4F20\u7684\u6587\u4EF6\u4E0D\u80FD\u8D85\u8FC7" + uploadParams.size + "M");
            return false;
        }
        var fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (uploadParams.accept) {
            var acceptArr = uploadParams.accept.split(',');
            if (acceptArr.indexOf("." + fileType) === -1) {
                this.$message.warning("\u53EA\u80FD\u4E0A\u4F20" + uploadParams.accept + "\u6587\u4EF6");
                return false;
            }
        }
    };
    // 上传成功
    QiniuUpload.prototype.uploadSuccess = function (res, file, fileList) {
        // 批量上传图片会执行多次， 批量上传文件只会执行一次
        var limit = this.uploadParams.limit || 1;
        if (fileList.length > limit) {
            this.$message.warning("\u6700\u591A\u4E0A\u4F20" + limit + "\u5F20\uFF0C\u5DF2\u4E3A\u60A8\u81EA\u52A8\u8FC7\u6EE4" + (fileList.length - limit) + "\u5F20");
            fileList = fileList.splice(0, limit);
        }
        var curIndex = fileList.indexOf(file); // 当前文件对象索引
        var uploadParams = this.uploadParams;
        if (uploadParams.isFile || this.getFileType(file.name) === 'file') {
            fileList.forEach(function (item) {
                item.url = uploadParams.domain + res.key + "?attname=" + item.name;
            });
        }
        else {
            fileList[curIndex].url = uploadParams.domain + res.key;
        }
        this.uploadFileList = fileList;
        this.$emit('emitUpload', this.uploadFileList);
    };
    QiniuUpload.prototype.uploadError = function (err) {
        // expired token
        var errMsg = JSON.parse(err.message).error;
        if (errMsg && errMsg === 'expired token') {
            this.getToken();
            this.$message.warning('上传超时，请重新上传!');
        }
    };
    // 删除图片
    QiniuUpload.prototype.imgRemove = function (file) {
        var url = file.url;
        var len = this.uploadFileList.length;
        for (var i = 0; i < len; i++) {
            if (url === this.uploadFileList[i].url) {
                this.uploadFileList.splice(i, 1);
                break;
            }
        }
        this.$emit('emitUpload', this.uploadFileList);
    };
    __decorate([
        Prop({
            type: Object,
            default: function () {
                return {
                    bucket: 'image',
                };
            },
        })
    ], QiniuUpload.prototype, "uploadParams", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: true,
        })
    ], QiniuUpload.prototype, "showPreviewIcon", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], QiniuUpload.prototype, "disabled", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () {
                return null;
            },
        })
    ], QiniuUpload.prototype, "imgStyle", void 0);
    __decorate([
        Watch('uploadParams', { immediate: true, deep: true })
    ], QiniuUpload.prototype, "uploadParamsHandler", null);
    QiniuUpload = __decorate([
        Component
    ], QiniuUpload);
    return QiniuUpload;
}(Vue));
export default QiniuUpload;
